/**
 * Shared layout constants for the chat chart widgets, so they're defined once
 * instead of being duplicated across ChatLineChart / ChatBarChart / ChatPieChart.
 */

// SVG viewBox dimensions (logical units; each chart's svg scales to its container
// width via the viewBox, so these are an aspect ratio, not pixels).
export const CHART_VIEW_W = 640
export const CHART_VIEW_H = 300

// Max rendered width on wide / full-width screens so charts don't balloon (the chat
// bubble and tables are free to grow to the full column width).
export const CHART_MAX_WIDTH = 750

// Default chart-area height. The graph panel's default WIDTH is derived from this and
// the viewBox ratio (width = height * VIEW_W / VIEW_H), so the chart fills the panel
// with no empty space. The user can then drag it wider (up to the full bubble width).
export const GRAPH_MAX_HEIGHT = 340

// Only a plain hex string is accepted as an agent/spec-supplied colour, so an arbitrary
// value can't slip into an SVG `fill` / CSS colour. Matches #rgb, #rgba, #rrggbb, #rrggbbaa.
const HEX_COLOR = /^#(?:[0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/

/**
 * Returns the colour only if it's a valid hex string, else undefined -- so a renderer can
 * do `sanitizeChartColor(spec.color) ?? palette[i]` (explicit colour wins, palette is the
 * fallback) without risking an unsafe value in an SVG fill.
 */
export function sanitizeChartColor(color: unknown): string | undefined {
  if (typeof color !== 'string') return undefined
  const trimmed = color.trim()
  return HEX_COLOR.test(trimmed) ? trimmed : undefined
}
